module.exports = __webpack_public_path__ + "static/media/picture7@2x.3c5db9f4.png";